'use strict';

var coreUtilityAliases = require('../var/coreUtilityAliases');

var hasOwn = coreUtilityAliases.hasOwn;

function getOwnKey(obj, key) {
  if (hasOwn(obj, key)) {
    return key;
  }
}

module.exports = getOwnKey;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar-date/common/internal/getOwnKey.js
// module id = 167
// module chunks = 1